import $ from 'jquery';
import fetch from 'utils/fetch';
import { error } from './toastr';
import { createModal } from 'utils/dynamic-modal';

const IDS_DATA_ATTR = 'data-value';
const DEFAULT_ACTION_METHOD = 'POST';

// Selectors
const selectionButtons = () => $('.actionBar .button.selection');
const basicButtons = () => $('.actionBar .button:not(.selection)');

export default function bind() {
  const $selectionButtons = selectionButtons();

  // Hidding selection buttons on load
  $selectionButtons.hide();

  // Binding selection buttons actions
  $selectionButtons.on('click', handleSelectionAction);
}

function getFetchAction($button, jsonBody) {
  const url = $button.attr('data-url');
  const method = $button.attr('data-method') || DEFAULT_ACTION_METHOD;

  if (url && url.length) {
    return () =>
      fetch(url, {
        headers: {
          'Content-Type': 'application/json',
        },
        method,
        body: jsonBody,
      }).then(res => {
        $button.removeClass('loading');
        window.location.replace(res.url);
      });
  }

  return null;
}

function handleSelectionAction(evt) {
  const selectedIds = $('.actionBar')
    .find('#selected-ids')
    .attr(IDS_DATA_ATTR);

  if (selectedIds && selectedIds.length) {
    // Serialize ids as JSON and execute given URL
    const idsArray = selectedIds.split(',').map(Number);
    const jsonBody = JSON.stringify(idsArray);

    const $button = $(evt.currentTarget);
    const fetchAction = getFetchAction($button, jsonBody);
    if (fetchAction) {
      // Checking if action need confirm, otherwise execute it
      const confirm = $button.attr('data-confirm');
      if (confirm && confirm.length) {
        const title = $button.attr('data-confirm-title');

        // Replacing #count content in confirm body
        const content = confirm.replace('#count', idsArray.length);

        // Handle confirmation before execution action
        confirmSelectionAction(content, title, fetchAction);
      } else {
        executeSelectionAction($button, fetchAction);
      }
    }
  }
}

function executeSelectionAction($button, fetchAction) {
  $button.addClass('loading');

  fetchAction().catch(err => {
    console.log('Error attempting to execute selection action', err);

    $button.removeClass('loading');
    error('Une erreur est survenue. Merci de réessayer ultérieurement');
  });
}

function confirmSelectionAction(confirm, title, fetchAction) {
  createModal(title, confirm, fetchAction, promise => {
    // Reloading page once execution finished
    promise.then(
      _ => window.location.reload(true),
      err => {
        err.res.json().then(cause => error(cause.error));
      }
    );
  });
}

export function setSelectionCount(count, ids) {
  const $actionBar = $('.actionBar');
  const $selection = $actionBar.find('p.selection');
  const $selectedIds = $actionBar.find('#selected-ids');

  // Fill data attributes for selected ids
  $selectedIds.attr(IDS_DATA_ATTR, ids);

  // Toggle action bar content depending on selection context
  if (count > 0) {
    const label = count > 1 ? 'sélections' : 'sélection';

    $selection.html(`${count} ${label}`);

    if (!$actionBar.hasClass('selection')) {
      $actionBar.addClass('selection');
      toggleButtons();
    }
  } else {
    $selection.html('0 sélection');

    $actionBar.removeClass('selection');
    toggleButtons();
  }
}

function toggleButtons() {
  basicButtons().toggle();
  selectionButtons().toggle();
}



// WEBPACK FOOTER //
// ./src/plugins/action-bar.js